import { useContext } from 'react';
import { AddressSelectionContext } from './AddressSelectionProvider';
import { useUser } from '../../hooks/useUser';
import { UserAddressDto } from '@kotipizzagroup/kotipizza-users-api-client';

export const useAddress = (): UserAddressDto | undefined => {
  const { inputAddress, addressBookAddressId } = useContext(AddressSelectionContext);
  const { user } = useUser();

  if (addressBookAddressId && user && user.addresses.length > 0) {
    return (
      user.addresses.find((address) => address.addressId === addressBookAddressId) ||
      inputAddress ||
      user.addresses[0]
    );
  } else if (inputAddress) {
    return inputAddress;
  } else {
    return undefined;
  }
};
